"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _client = require("@apollo/client");

var _PCH_USER = _interopRequireDefault(require("../graphql/PCH_USER"));

var _ADD_USER_PCH = _interopRequireDefault(require("../graphql/ADD_USER_PCH"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var usePchLookup = function usePchLookup(pt1, pt2, hsid, dispatchTracking) {
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      pchUser = _useState2[0],
      setPchUser = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      pchComplete = _useState4[0],
      setPchComplete = _useState4[1];

  var _useMutation = (0, _client.useMutation)(_ADD_USER_PCH.default, {
    onCompleted: function onCompleted() {
      console.log('PCH User added to Mongo. Setting flag to complete.');
      setPchComplete(true);
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      addUserPCH = _useMutation2[0];

  var handleError = function handleError() {
    console.log('Error occurred during pch lookup. Check API logs...');
    setPchComplete(true);
  };

  var handleCompletion = function handleCompletion(data) {
    if (data.fetchUserInfo.success) {
      console.log('Fetched PCH user data:', data.fetchUserInfo.message);
      var userRes = data.fetchUserInfo.body;
      var userData = {
        title: userRes['Title'],
        email: userRes['EmailAddress'],
        fname: userRes['FirstName'],
        lname: userRes['LastName'],
        address: userRes['Address1'],
        city: userRes['City'],
        state: userRes['State'],
        zip: userRes['ZipCode']
      };
      dispatchTracking({
        type: 'SET_PCH_USER',
        payload: userData
      });
      setPchUser(userData); // We arent finished yet... need to post to mongo before flag switch

      return;
    }

    ; // Error occurred during lookup...lets move on.

    setPchComplete(true);
    return;
  };

  (0, _client.useQuery)(_PCH_USER.default, {
    variables: {
      pat: pt1,
      gmt: pt2
    },
    errorPolicy: 'all',
    onCompleted: handleCompletion,
    onError: handleError,
    skip: pt1 === 'N/A' || pt2 === 'N/A' || !!pchUser
  });
  (0, _react.useEffect)(function () {
    if (pt1 === 'N/A' || pt2 === 'N/A') {
      setPchComplete(true);
    }

    ; // eslint-disable-next-line
  }, []);
  (0, _react.useEffect)(function () {
    if (!!pchUser && !!hsid) {
      addUserPCH({
        variables: {
          clickId: hsid,
          pch: {
            gmt: pt2,
            title: pchUser['title'],
            firstname: pchUser['fname'],
            lastname: pchUser['lname'],
            address: pchUser['address'],
            city: pchUser['city'],
            state: pchUser['state'],
            zipcode: pchUser['zip']
          }
        }
      });
    }

    ; // eslint-disable-next-line
  }, [pchUser, hsid]);
  return pchComplete;
};

var _default = usePchLookup;
exports.default = _default;

//# sourceMappingURL=usePchLookup.jsx.map